import React, { Component } from "react";

import { inject, observer } from "mobx-react";

import { Grid, Paper } from "@material-ui/core";

import WidgetContainer from "../widget/WidgetContainer.js";
import ResponsiveTable from "../table/ResponsiveTable";
import moment from "moment";

import "./UpcomingBooking.css";
import { Link } from "react-router-dom";
import { BookingType, LineupStatusType, ProfileType, RosterDividendType } from "../../types/enum.js";
import currencyHelper from '../../helper/currency';
import bookingCalculationHelper from "../../helper/bookingCalculationHelper.js"
@inject("profileStore", "bookingRequestStore", "templateStore")
@observer
class UpcomingBookingMusician extends Component {
    state = {
        venue: "null",
        consultant: "null",        
        columns: [
            { key: "date", label: "Date", width: "10%", sortable: true, isDate:true, addComp:true, style: {whiteSpace: 'nowrap'} },
            { key: "venueName", label: "Venue", width: "20%" },
            { key: "actName", label: "Artist", width: "15%" },
            { key: "gigFee", label: "Venue/Client Fee", sortable: true, isNumber:true, width: "7.5%", align: 'left', style: { flexDirection: 'row' } },
            { key: "agentCommissionAmount", label: "Agent Fee", sortable: true, isNumber: true, width: "7.5%", align: 'left', style: { flexDirection: 'row' } },
            { key: "myFee", label: "My Fee", sortable: true, isNumber:true, width: "7.5%", align: 'left', style: { flexDirection: 'row' } },
            { key: "superFee", label: "Super Fee", sortable: true, width: "7.5%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
            { key: "feePaidToAct", label: "Invoice Amount", sortable: true, width: "7.5%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
            { key: "agentContact", label: "Booking Creator", width: "7.5%", align: 'left', style: { whiteSpace: 'nowrap' } }
        ]
    };

    tableData = {
        title: ["Date", "Venue", "Address", "Artist", "Time", "Consultant"]
    };

    mapBookingDataToRowData = () => {
        const { tableData } = this.props
        const { currentProfile } = this.props.profileStore;
        
        if (tableData && currentProfile) {
            return tableData.map(booking => {
                var row = {};
                let time = booking.timeStart.length < 8 ? `0${booking.timeStart}` : booking.timeStart;                
                row.date = {value:`${booking.dateStart.format("DD MMM YYYY")} ${moment(time).format('hh.mm A')}`, newFormat: <Link to={this.bookingRedirectPath(booking)} target={"_blank"}>{booking.dateStart.format("DD MMM YYYY")} {moment(time).format('hh.mm A')}</Link>};
                row.venueName = (
                    <div>
                        <span>{booking.venue && booking.venueId ? booking.venue.profileName : booking.venueName}</span>
                        <br />
                        <small>{booking.venueAddress}</small>
                    </div>
                );

                const isEntertainerBookings = currentProfile?.type === ProfileType.Musician.ordinal && booking.createdById === currentProfile?.id && !booking.act?.actName;

                row.actName = <Link to={`/profile/${isEntertainerBookings ? currentProfile?.id : booking.act?.id}`} target={"_blank"}>{isEntertainerBookings ? `${currentProfile?.firstName} ${currentProfile?.lastName}` : booking.act?.actName}</Link>

                var collectedFee = bookingCalculationHelper.calculatedBookingFee(booking, currentProfile)
                               
               
                row.gigFee = booking.createdBy?.type === ProfileType.Agent.ordinal && (booking.agentOwner?.hideVenueFees && currentProfile?.type === ProfileType.Musician.ordinal) ? <i className={"icon-eye-blocked"} /> : ((currentProfile && currentProfile.currencySymbol) ? currentProfile.currencySymbol : "$") + currencyHelper.formatMoney(booking.gigFee, 2)
                
                
                row.myFee = ((currentProfile && currentProfile.currencySymbol) ? currentProfile.currencySymbol : "$") + currencyHelper.formatMoney(collectedFee.myFee, 2)
                row.agentCommissionAmount = collectedFee.agentCommissionAmount
                row.superFee = collectedFee.superFee
                row.feePaidToAct = collectedFee.feePaidToAct
                let isAgency = booking.createdBy.type === ProfileType.Agent.ordinal && booking.provider;
                row.agentContact = isAgency ? booking.provider : booking.createdBy.firstName + " " + booking.createdBy.lastName;
                
                return row;
            })
        }
        else {
            return [];
        }
    };

    bookingRedirectPath = (booking) => {
        const { currentProfile } = this.props.profileStore;
        const isEntertainerBookings = currentProfile?.type === ProfileType.Musician.ordinal && booking.createdById === currentProfile?.id && !booking.act?.actName;
        let path = `/booking/${booking.id}/edit`
        if (booking.type === BookingType.Adhoc.ordinal) path = `/privateBooking/${booking.id}/edit`;
        else if (isEntertainerBookings) path = `/booking/${booking.id}/edit`
        else if (currentProfile.type === ProfileType.Musician.ordinal) path = `/musician/booking/${booking.id}/details`;

        return path;
    };

    handleVenueChange = event => {
        this.setState({ venue: event.target.value });
    };

    handleConsultantChange = event => {
        this.setState({ consultant: event.target.value });
    };

    render() {
        return (
            <Paper>
                <WidgetContainer
                    title="Upcoming Gigs"
                    showBadge={this.props.tableData && this.props.tableData.length ? true : false}
                    badgeValue={this.props.tableData && this.props.tableData.length}
                >
                    <Grid container spacing={16}>
                        <Grid item xs={12}>
                            <ResponsiveTable
                                sortable={true}
                                columns={this.state.columns}
                                rows={this.mapBookingDataToRowData()}
                            />
                        </Grid>
                    </Grid>
                </WidgetContainer>
            </Paper>
        );
    }
}

export default UpcomingBookingMusician;
